<template>
  <div class="vf-form-field" :data-field-type="field.dataType">
    <label class="vf-form-field-label">{{ field.fieldName }} <span v-if="field.required" class="required-indicator">*</span></label>
    
    <div class="vf-form-field-content">

      <div v-if="editMode">
        <!-- Checkboxes -->
        <div v-if="field.allowMultipleValues" class="choice-options">
          <div v-for="(option, index) in field.options" :key="index" class="choice-option">
            <label>
              <input
                type="checkbox"
                :value="option"
                :name="fieldName"
                v-model="selectedValues"
                @change="updateCheckboxValues" />
              {{ option }}
            </label>
          </div>
        </div>

        <!-- Dropdown -->
        <div v-if="!field.allowMultipleValues">
          <select
            v-model="field.value"
            class="form-control"
            :name="fieldName"
            :required="field.required">
            <option value="">-- Select an option --</option>
            <option v-for="(option, index) in field.options" :key="index" :value="option">
              {{ option }}
            </option>
          </select>
        </div>

        <div v-if="field.description" class="vf-form-field-description" v-html="textToHtml(field.description)"></div>
      </div>
      <div v-else>
        <div v-if="field.allowMultipleValues">
          <span v-if="field.value && field.value.length">{{ field.value.join(', ') }}</span>
          <span v-else class="text-muted">No response</span>
        </div>
        <div v-else>
          <span v-if="field.value">{{ field.value }}</span>
          <span v-else class="text-muted">No response</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { buildFieldName, textToHtml } from '../../Forms/form-helper.js';

  export default {
    name: 'MultipleChoiceFieldRenderer',
    props: {
      field: {
        type: Object,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        fieldName : buildFieldName(this.field),
        options : [],
        selectedValues: []
      };
    },
    mounted() {

      if(this.field.multiChoiceOptions) {
        this.options = this.field.multiChoiceOptions.split('\n').map(opt => opt.trim()).filter(opt => opt);
        this.field.options = this.options;
      }

      // Initialize selectedValues for checkboxes
      if (this.field.allowMultipleValues && this.field.value) {
        if (Array.isArray(this.field.value)) {
          this.selectedValues = [...this.field.value];
        } else {
          this.selectedValues = [this.field.value];
        }
      }
    },
    methods: {
      updateCheckboxValues() {
        this.field.value = this.selectedValues;
      },
      textToHtml
    },
  };
</script>

<style scoped>
  .vf-field {
    margin-bottom: 20px;
  }

  .vf-field-label {
    display: block;
    font-weight: 600;
    margin-bottom: 5px;
  }

  .vf-field-description {
    color: #6c757d;
    font-size: 0.9em;
    margin-bottom: 8px;
  }

  .required-indicator {
    color: #d9534f;
    margin-left: 3px;
  }

  .choice-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .choice-option {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .choice-option label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    margin-bottom: 0;
  }

  .choice-option input[type="radio"],
  .choice-option input[type="checkbox"] {
    margin: 0;
  }

  .other-input {
    max-width: 300px;
  }
</style>
